// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ReffsControlPage {
  padding-left: 281px;
  background: #EFF0F4;
  width: 100%;
  min-height: 100vh;
}
.ReffsControlPage .titleBlock {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #fff;
  padding: 43px 40px 27px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
}
.ReffsControlPage .titleBlock span {
  font-family: "Montserrat Regular";
  font-weight: 500;
  font-size: 24px;
  color: #1a1a1a;
}
.ReffsControlPage .ant-card {
  transition: all 0.3s ease;
}
.ReffsControlPage .ant-card:hover {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.12) !important;
}
.ReffsControlPage .ant-statistic-title {
  font-size: 14px;
  color: #666;
  margin-bottom: 8px;
}
.ReffsControlPage .ant-table-wrapper .ant-table {
  border-radius: 12px;
}
.ReffsControlPage .ant-table-wrapper .ant-table-thead > tr > th {
  background: #fafafa;
  font-weight: 500;
  color: #1a1a1a;
}
@media (max-width: 768px) {
  .ReffsControlPage {
    padding-left: 0;
  }
  .ReffsControlPage .titleBlock {
    flex-direction: column;
    align-items: flex-start;
    gap: 16px;
    padding: 24px;
  }
  .ReffsControlPage .titleBlock .ant-select {
    width: 100% !important;
    margin-left: 0 !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/routes/pages/ReffsControlPage/ReffsControlPage.scss"],"names":[],"mappings":"AAAA;EACI,mBAAA;EACA,mBAAA;EACA,WAAA;EACA,iBAAA;AACJ;AACI;EACI,WAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,gBAAA;EACA,uBAAA;EACA,yCAAA;AACR;AACQ;EACI,iCAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;AACZ;AAII;EACI,yBAAA;AAFR;AAIQ;EACI,qDAAA;AAFZ;AAOI;EACI,eAAA;EACA,WAAA;EACA,kBAAA;AALR;AAUQ;EACI,mBAAA;AARZ;AAWQ;EACI,mBAAA;EACA,gBAAA;EACA,cAAA;AATZ;AAcI;EArDJ;IAsDQ,eAAA;EAXN;EAaM;IACI,sBAAA;IACA,uBAAA;IACA,SAAA;IACA,aAAA;EAXV;EAaU;IACI,sBAAA;IACA,yBAAA;EAXd;AACF","sourcesContent":[".ReffsControlPage {\n    padding-left: 281px;\n    background: #EFF0F4;\n    width: 100%;\n    min-height: 100vh;\n    \n    .titleBlock {\n        width: 100%;\n        display: flex;\n        align-items: center;\n        justify-content: space-between;\n        background: #fff;\n        padding: 43px 40px 27px;\n        box-shadow: 0 2px 8px rgba(0,0,0,0.06);\n\n        span {\n            font-family: \"Montserrat Regular\";\n            font-weight: 500;\n            font-size: 24px;\n            color: #1a1a1a;\n        }\n    }\n\n    // Стили для карточек\n    .ant-card {\n        transition: all 0.3s ease;\n        \n        &:hover {\n            box-shadow: 0 4px 12px rgba(0,0,0,0.12) !important;\n        }\n    }\n\n    // Стили для статистики\n    .ant-statistic-title {\n        font-size: 14px;\n        color: #666;\n        margin-bottom: 8px;\n    }\n\n    // Стили для таблицы\n    .ant-table-wrapper {\n        .ant-table {\n            border-radius: 12px;\n        }\n        \n        .ant-table-thead > tr > th {\n            background: #fafafa;\n            font-weight: 500;\n            color: #1a1a1a;\n        }\n    }\n\n    // Адаптивность\n    @media (max-width: 768px) {\n        padding-left: 0;\n        \n        .titleBlock {\n            flex-direction: column;\n            align-items: flex-start;\n            gap: 16px;\n            padding: 24px;\n            \n            .ant-select {\n                width: 100% !important;\n                margin-left: 0 !important;\n            }\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"ReffsControlPage": `ReffsControlPage`,
	"titleBlock": `titleBlock`,
	"ant-card": `ant-card`,
	"ant-statistic-title": `ant-statistic-title`,
	"ant-table-wrapper": `ant-table-wrapper`,
	"ant-table": `ant-table`,
	"ant-table-thead": `ant-table-thead`,
	"ant-select": `ant-select`
};
export default ___CSS_LOADER_EXPORT___;
